// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".limit-lines[data-v-44507a00]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}[data-v-44507a00] .placeholder img{-o-object-fit:contain!important;object-fit:contain!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
